export default {
  beforeDestroy () {
    this.clearStyle()
  },
  methods: {
    clearStyle () {
      document.querySelector('.pageWrap>.content-scrollbar>.el-scrollbar__wrap').style.overflow = null
      document.querySelector('.pageWrap>.content-scrollbar>.el-scrollbar__wrap').style.paddingRight = null

      document.querySelector('.pageWrap>.content-scrollbar>.is-vertical').style.display = null
      document.querySelector('.pageWrap>.content-scrollbar>.is-horizontal').style.display = null
    },
    setStyle () {
      document.querySelector('.pageWrap>.content-scrollbar>.el-scrollbar__wrap').style.overflow = 'hidden'
      // document.querySelector('.pageWrap>.content-scrollbar>.el-scrollbar__wrap').style.paddingRight = '17px'
      document.querySelector('.pageWrap>.content-scrollbar>.el-scrollbar__wrap').style.paddingRight = '6px'
      document.querySelector('.pageWrap>.content-scrollbar>.is-vertical').style.display = 'none'
      document.querySelector('.pageWrap>.content-scrollbar>.is-horizontal').style.display = 'none'
    },
    focus () {
      this.setStyle()
    },
    blur () {
      this.clearStyle()
    }
  }
}
